import React, { useState } from 'react'
import { Edit, useForm, BooleanField, RefreshButton } from '@refinedev/antd';
import { Form, Input, Checkbox, Button, FormProps, Modal } from "antd";
import { useSchemaDB } from 'hooks/useSchemaDB';
import { ChildForm, FieldDB, TableDB } from 'interfaces/schemaDB';
import Cw8Form from './Cw8Form';
import { useNavigation, useShow, BaseKey } from '@refinedev/core';
import { CrudFilters } from '@refinedev/core/dist/interfaces';
import { FormMode } from 'interfaces/interfaces';
import { PlusOutlined } from '@ant-design/icons';
import { config } from 'config';
import { useParams } from 'react-router-dom';


interface Cw8EditProps {
    resourceName: string
    idResource ?:string | BaseKey
    // filterList?: CrudFilters
    childrenForms?: ChildForm[]
    editFormProps?: FormProps
    modal ?:boolean
}

const Cw8Edit = ({resourceName,  childrenForms, editFormProps, idResource , modal}: Cw8EditProps) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [duplicatedId, setDuplicatedId] = useState<string | null>(null);
    const { edit } = useNavigation();
    const { id } = useParams();

    const handleDuplicate = async () => {
    try {
        const response = await fetch(`${config.urlAPI}/duplicarBV/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) throw new Error("Error duplicando recurso");

        const result = await response.json(); // { id: "123" }
        console.log(result)
        setDuplicatedId(result[0].bv_id);
        setIsModalOpen(true);
    } catch (error) {
        console.error("Fallo al duplicar:", error);
    }
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const handleYes = () => {
        setIsModalOpen(false);
        edit("bibliotecaVirtual", duplicatedId!);
    };

    const handleNo = () => {
        setIsModalOpen(false);
    };

    // console.log(id);
    
    const { goBack } = useNavigation();
    const { form, formProps, saveButtonProps, queryResult } = useForm({
        resource : resourceName,
        redirect : false,
        id: idResource ?idResource :undefined,
        onMutationSuccess: (data, variables, context) => {
            // console.log({ data, variables, context });
          resourceName !== "bibliotecaVirtual" && goBack()
        }
    });

    const { queryResult : queryResulthow, setShowId  } = useShow({
        resource : resourceName,
        id: idResource?idResource:undefined
    });


    const { data, isLoading } = queryResulthow;
    const record = data?.data;

    const { showId } = useShow({
        resource: resourceName
    });
    // console.log(resourceName, showId);

    const {schemaDBState,  getTable, getEditField, childrenTables, setCurrentChildrenTables } = useSchemaDB({nameTable:resourceName})

    // if( childrenForms ){
    //     // setCurrentChildrenTables(childrenForms) //////////QUITE ESTO Y FUNCIONO, VALIDAR PARA AQUE ES
    //     //ESTO HACE QUE EL ESCHEMA SE RECARGUE Y AL RECARGARSE SE CREA UN LOOP
    // }else{
    //     // console.log(childrenTables )
    // }

    const table = getTable(resourceName)
    const fieldList = getEditField(table?table?.length>0?table[0]:null:null, childrenTables) 
    const tabs = table?table?.length>0?table[0]?.tabs:null:null

    return (
        
            !modal?(
                <Edit   
                    saveButtonProps={saveButtonProps} 
                    resource={resourceName}
                    recordItemId = {idResource?idResource:undefined}
                    headerButtons={({ defaultButtons }) => (
                        <>
                            {defaultButtons}
                            {
                                resourceName === "bibliotecaVirtual" && (
                                    <Button
                                        icon={<PlusOutlined />}
                                        onClick={handleDuplicate}
                                    >
                                        Duplicar
                                    </Button>
                                )
                            }
                        </>
                    )} 
                    breadcrumb={<span></span>}
                >
                    <Cw8Form
                        fieldList = {fieldList}
                        tabs = {tabs}
                        formProps = {editFormProps?editFormProps:formProps}
                        record  = {record}
                        formMode =  {FormMode.edit}
                        resourceName = {resourceName}
                        form = {form}
                        // filterList = {filterList}
                        id = {idResource}
                    ></Cw8Form>
                          <Modal
                            title="Se ha duplicado el registro"
                            open={isModalOpen}
                            onCancel={handleNo}
                            footer={[
                                <Button key="no" onClick={handleNo}>No</Button>,
                                <Button key="yes" type="primary" onClick={handleYes}>Sí, editar</Button>,
                            ]}
                          >
                            <p>¿Le gustaría ir a editar el recurso con ID <strong>{duplicatedId}</strong>?</p>
                          </Modal>
                </Edit>                
            ):(
                <Cw8Form
                    fieldList = {fieldList}
                    tabs = {tabs}
                    formProps = {editFormProps?editFormProps:formProps}
                    record  = {record}
                    formMode =  {FormMode.edit}
                    resourceName = {resourceName}
                    form = {form}
                    // filterList = {filterList}
                    childrenForms = {table?(table.length>0?(table[0].childrenForms?table[0].childrenForms:[]):[]):[]}   
                    id = {idResource}
                ></Cw8Form>
            )
        
    )
}

export default Cw8Edit
